import React, { useState } from "react";
import { Modal, Button, Form, InputGroup, Spinner } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useMutation } from "@tanstack/react-query";
import { changeUserPassword } from "../../../api/USERS/users";
import { toast } from "react-toastify";

const ChangeUserPassword = ({ show, setShow, user }) => {
  const [nouveau, setNouveau] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const mutation = useMutation({
    mutationFn: ({ userId, password }) => changeUserPassword(userId, password),
  });

  const handleClose = () => {
    setShow(false);
    setNouveau("");
    setConfirm("");
    setShowPassword(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (nouveau.length < 8) {
      toast.error("Le mot de passe doit contenir au moins 8 caractères");
      return;
    }

    if (nouveau !== confirm) {
      toast.error("Les mots de passe ne correspondent pas");
      return;
    }

    mutation.mutate(
      { userId: user.id, password: nouveau },
      {
        onSuccess: () => {
          toast.success(`Mot de passe de ${user.name} ${user.surname} modifié`);
          handleClose();
        },
        onError: (error) => {
          toast.error(error.message || "Erreur lors du changement de mot de passe");
        },
      }
    );
  };

  if (!user) return null;

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Changer le mot de passe — {user.name} {user.surname}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Nouveau mot de passe</Form.Label>
            <InputGroup>
              <Form.Control
                type={showPassword ? "text" : "password"}
                value={nouveau}
                onChange={(e) => setNouveau(e.target.value)}
                placeholder="Minimum 8 caractères"
                autoComplete="new-password"
                required
              />
              <Button
                variant="outline-secondary"
                onClick={() => setShowPassword((v) => !v)}
                tabIndex={-1}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </Button>
            </InputGroup>
          </Form.Group>

          <Form.Group>
            <Form.Label>Confirmer le mot de passe</Form.Label>
            <Form.Control
              type={showPassword ? "text" : "password"}
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="Répéter le mot de passe"
              autoComplete="new-password"
              isInvalid={confirm.length > 0 && nouveau !== confirm}
              required
            />
            <Form.Control.Feedback type="invalid">
              Les mots de passe ne correspondent pas
            </Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Annuler
          </Button>
          <Button
            type="submit"
            variant="warning"
            disabled={mutation.isPending}
          >
            {mutation.isPending ? (
              <Spinner size="sm" animation="border" />
            ) : (
              "Enregistrer"
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ChangeUserPassword;
